export const CREATE_BOARD = "CREATE_BOARD";
export const CREATE_BOARD_SUCCESS = "CREATE_BOARD_SUCCESS";
export const CREATE_BOARD_FAIL = "CREATE_BOARD_FAIL";

export const GET_BOARDS_LIST = "GET_BOARDS_LIST";
export const GET_BOARDS_LIST_SUCCESS = "GET_BOARDS_LIST_SUCCESS";
export const GET_BOARDS_LIST_FAIL = "GET_BOARDS_LIST_FAIL";

export const FETCH_SLIDES = "FETCH_SLIDES";
export const FETCH_SLIDES_SUCCESS = "FETCH_SLIDES_SUCCESS";
export const FETCH_SLIDES_FAIL = "FETCH_SLIDES_FAIL";

export const ADD_SLIDE = "ADD_SLIDE";
export const ADD_SLIDE_SUCCESS = "ADD_SLIDE_SUCCESS";
export const ADD_SLIDE_FAIL = "ADD_SLIDE_FAIL";

export const LOGIN_TO_NOTICE_BOARD = "LOGIN_TO_NOTICE_BOARD";
export const LOGIN_TO_NOTICE_BOARD_SUCCESS = "LOGIN_TO_NOTICE_BOARD_SUCCESS";
export const LOGIN_TO_NOTICE_BOARD_FAIL = "LOGIN_TO_NOTICE_BOARD_FAIL";

export const UPDATE_SLIDE = "UPDATE_SLIDE";
export const UPDATE_SLIDE_SUCCESS = "UPDATE_SLIDE_SUCCESS";
export const UPDATE_SLIDE_FAIL = "UPDATE_SLIDE_FAIL";

export const DELETE_SLIDE = "DELETE_SLIDE";
export const DELETE_SLIDE_SUCCESS = "DELETE_SLIDE_SUCCESS";
export const DELETE_SLIDE_FAIL = "DELETE_SLIDE_FAIL";

export const RESET_NOTICE_BOARD_PASSWORD = "RESET_NOTICE_BOARD_PASSWORD";
export const RESET_NOTICE_BOARD_PASSWORD_SUCCESS = "RESET_NOTICE_BOARD_PASSWORD_SUCCESS";
export const RESET_NOTICE_BOARD_PASSWORD_FAIL = "RESET_NOTICE_BOARD_PASSWORD_FAIL";

export const CHECK_BOARD_ACTIVITY = "CHECK_BOARD_ACTIVITY";
export const CHECK_BOARD_ACTIVITY_SUCCESS = "CHECK_BOARD_ACTIVITY_SUCCESS";
export const CHECK_BOARD_ACTIVITY_FAIL = "CHECK_BOARD_ACTIVITY_FAIL";

export const DELETE_BOARD = "DELETE_BOARD";
export const DELETE_BOARD_SUCCESS = "DELETE_BOARD_SUCCESS";
export const DELETE_BOARD_FAIL = "DELETE_BOARD_FAIL";
